import { render, staticRenderFns } from "./HomeNumber.vue?vue&type=template&id=aca30dfa"
import script from "./HomeNumber.vue?vue&type=script&lang=js"
export * from "./HomeNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports